// extracted by mini-css-extract-plugin
export default {"arrowIcon":"IfFVl","opened":"eGvvG"};